const DEFAULT_ITEMS_PER_PAGE = 50;

export {
  DEFAULT_ITEMS_PER_PAGE,
};
